module.exports = __webpack_public_path__ + "static/img/charge4.c3f7cb7f.png";